import { getLang } from "@/lib/i18n";

let CUR = "AUD";
const symCache = {};

export const getCurrency = () => CUR;
export const setCurrency = (c) => { CUR = c || "AUD"; };

export function curSymbol(code = CUR) {
  if (symCache[code]) return symCache[code];
  let s = code;
  try {
    const part = (d) => new Intl.NumberFormat("en", { style: "currency", currency: code, currencyDisplay: d }).formatToParts(0).find((p) => p.type === "currency")?.value;
    s = part("symbol") || code;
    if (s === code) s = part("narrowSymbol") || code;
  } catch (e) { s = code; }
  if (code === "AUD") s = "A$";
  symCache[code] = s;
  return s;
}

export function curName(code) {
  try { return new Intl.DisplayNames(["en"], { type: "currency" }).of(code); } catch (e) { return code; }
}

export const money = (n, code = CUR) => {
  const v = Number(n) || 0;
  const s = curSymbol(code) + Math.abs(v).toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return v < 0 ? "−" + s : s;
};

export const iso = (d) => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
export const today = () => iso(new Date());
export const sumA = (arr, f = () => true) => arr.reduce((t, i) => (f(i) ? t + (+i.amt || 0) : t), 0);
export const ds = (d, o) => d.toLocaleDateString(getLang() === "bn" ? "bn-BD" : "en-AU", o);

export function range(mode, anchor) {
  const a = new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate());
  if (mode === "year") return [new Date(a.getFullYear(), 0, 1), new Date(a.getFullYear() + 1, 0, 1)];
  if (mode === "month") return [new Date(a.getFullYear(), a.getMonth(), 1), new Date(a.getFullYear(), a.getMonth() + 1, 1)];
  const w = (a.getDay() + 6) % 7;
  const s = new Date(a.getFullYear(), a.getMonth(), a.getDate() - w);
  return [s, new Date(s.getFullYear(), s.getMonth(), s.getDate() + 7)];
}

export function shift(mode, anchor, n) {
  if (mode === "year") return new Date(anchor.getFullYear() + n, 0, 1);
  if (mode === "month") return new Date(anchor.getFullYear(), anchor.getMonth() + n, 1);
  return new Date(anchor.getFullYear(), anchor.getMonth(), anchor.getDate() + 7 * n);
}

export function periodLabel(mode, s, e) {
  if (mode === "year") return String(s.getFullYear());
  if (mode === "month") return ds(s, { month: "long", year: "numeric" }).toUpperCase();
  return ds(s, { day: "numeric", month: "short" }) + " – " + ds(new Date(e.getFullYear(), e.getMonth(), e.getDate() - 1), { day: "numeric", month: "short", year: "numeric" });
}

export const monthKey = (d) => d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0");
